import React from 'react';
import YouTube from 'react-youtube';

const VideoCard = ({ title, description, videoId }) => {
  const opts = {
    height: '100%',
    width: '100%',
    playerVars: {
      autoplay: 0, 
    },
  };

  return (
    <div className="bg-white rounded-lg shadow-lg overflow-hidden w-full">
      <div className="relative w-30 h-40">
        <YouTube videoId={videoId} opts={opts} className="w-full h-full rounded-t-lg" />
      </div>
      <div className="p-4">
        <h3 className="text-xl font-bold mb-2">{title}</h3>
        <p className="text-gray-600">{description}</p>
      </div>
    </div>
  );
};

export default VideoCard;